// extracted by mini-css-extract-plugin
export default {"popup":"Popup--popup--PJlVo","contents":"Popup--contents--+lu-8","arrow":"Popup--arrow--4YTC8"};